'use strict';
import {EwSiteApp} from '../../app/ewsiteapp.js';

$(document).ready(function(){
	if (!$("#popup_window").length) { // init if not in dialog view
		dinamicSubmenuTop();
	}
});

function dinamicSubmenuTop() {
	var $dinamicSubmenu = $('.has-sm-t-d');
	
	if ($dinamicSubmenu.length > 0 && $('.s--measures').length > 0 && $('.header__b').length > 0) {
		this.$measures = $('.s--measures');
		this.$header = $('.header');
		this.$headerBottom = $('.header__b');
		
		this.$headerHeight = this.$header.height();
		this.$measuresOffset = this.$measures.offset();
		this.$measuresHeight = this.$measures.height();
		this.$windowWidth = $(window).outerWidth(true);
		
		var self = this;
		
		this.updateValues = function(){
			self.$headerHeight = $header.height();
			self.$measuresOffset = $measures.offset();
			self.$measuresHeight = $measures.height();
			self.$windowWidth = $(window).outerWidth(true);
		};
		
		this.calcDistance = function(){
			if ($(window).scrollTop() + self.$headerHeight > self.$measuresOffset.top + self.$measuresHeight) {
				self.$headerBottom.addClass('visible');
			}
			else{
				self.$headerBottom.removeClass('visible');
			}
		};
		
		setTimeout(function(){
			self.updateValues();
			if (self.$windowWidth > 991) {
				self.calcDistance();
			}
		}, 50);
		
		window.onscroll = function(){
			if (self.$windowWidth > 991) {
				self.calcDistance();
			}
		};
		window.onresize = function(){
			self.updateValues();
			if (self.$windowWidth > 991) {
				self.calcDistance();
			}
		};
	}
}
